package br.com.texeratx.boardgametimeapp.ui.screens.matches

enum class MatchSortOption {
    DATE_DESC,
    DATE_ASC,
    DURATION_DESC,
    DURATION_ASC
}
